import { combineReducers } from "redux";
import searchResultsReducer from "./searchResultsReducer";
import searchMetadataReducer from "./searchMetadata";

export const casesReducer = combineReducers({
    searchResults: searchResultsReducer,
    searchMetadata: searchMetadataReducer,
});
